export const INFLUENCER_LIST_QUERY_KEY = ["influencers"];
export const INFLUENCER_REQUIREMENTS_LIST_QUERY_KEY = [
  "influencers-requirements",
];

export const SOCIAL_MEDIA_INFLUENCER_QUERY_KEY = ["social-media-influencer"];

export const INFLUENCER_REQUESTS_QUERY_KEY = ["influencer-requests"];

export const INFLUENCER_SUGGEST_REQUEST_FACETS = ["influencer-suggest-facets"];

export const INFLUENCER_CONTACT_VERIFICATION_QUERY_KEY = [
  "influencer-contact-verification",
];
